import { render } from "./homepage.vue?vue&type=template&id=7d0dd77b&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"

import "./homepage.vue?vue&type=style&index=0&id=7d0dd77b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0dd77b"]])

export default __exports__